import React, { useState } from 'react';
import './BuySellAdjustmentModal.scss';
import { BuySellAdjustmentTable } from '@widgets/BuySellAdjustmentTable';
import { FaShare } from 'react-icons/fa';
import { createTradeOrder } from '@pages/Preferences/api';
import { useNotify } from '@features/Notify';
import { ShareButton } from '../OrderConfirmDialog/OrderConfirmDialog';
import { ReactComponent as BarsIcon } from '../../../../shared/assets/svgs/BarsIcon.svg';

interface BuySellAdjustmentModalProps {
    userId: number;
}

export const BuySellAdjustmentModal: React.FC<BuySellAdjustmentModalProps> = ({ userId }) => {
    const [getTableData, setGetTableData] = useState<() => any[]>(() => () => []);
    const [hasShared, setHasShared] = useState(false);
    const [isSharing, setIsSharing] = useState(false);
    const notify = useNotify();
    const handleShareClick = async () => {
        const currentData = getTableData();
        if (currentData.length > 0) {
            setIsSharing(true);
            // For single order
            const jobId = currentData[0].jobId;

            try {
                var result = await createTradeOrder({
                    JobId: jobId,
                    TradeOrderStatus: 'Pending',
                });
                setHasShared(true);
                notify.success(result);
            } catch (error) {
                notify.error('Error creating trade order.');
            } finally {
                setIsSharing(false); // Set loading to false when done
            }
        }
    };
    return (
        <div className='widget-preference-table-modal'>
            <div className='widget-preference-table-modal__header'>
                <BarsIcon />
                <div className='widget-buy-sell-header'>
                    <div className='widget-preference-table-modal__title'>Determine Buy/Sell Adjustments </div>
                    <ShareButton
                        onShare={handleShareClick}
                        disabled={!getTableData || getTableData().length === 0}
                        hasShared={hasShared}
                        loading={isSharing}
                    />
                </div>
            </div>

            <div className='widget-buy-sell-table-modal__content'>
                <BuySellAdjustmentTable
                    accountId={userId}
                    setDataGetter={setGetTableData}
                />
            </div>
        </div>
    );
};
